import { render, staticRenderFns } from "./TransactionsSubPurchasesSearch.vue?vue&type=template&id=29884442"
import script from "./TransactionsSubPurchasesSearch.vue?vue&type=script&lang=js"
export * from "./TransactionsSubPurchasesSearch.vue?vue&type=script&lang=js"
import style0 from "./TransactionsSubPurchasesSearch.vue?vue&type=style&index=0&id=29884442&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports